import { CropsConditionState } from "./types";
import logger from "../../../../utils/logger";
import { createSlice } from "@reduxjs/toolkit";
import { applyExtraReducer } from "../../weather";
import { DashboardQueryParams } from "@pages/dashboard/phases";
import { createThunk, DashboardReqBodyWithDate } from "../crops/selector";
import { CropConditionData } from "@baseTypes/service/dashboard/IScoutingDashboardService";
import { dashboardURL } from "@utils/utils";

const initialState: CropsConditionState = {
    data: {
        total: 0,
        fieldConditions: []
    },
    isApiLoading: true,
    apiError: undefined
}

const log = logger.getLogger("cropsconditions.dash")

const fetchCropsConditions = createThunk<CropConditionData, DashboardQueryParams, DashboardReqBodyWithDate>()(
    { url: dashboardURL('fieldConditionsByDate'), method: "POST" },
    (payload, url) => ({
        url,
        data: {
            cropRotationIds: payload.cropRotationIds || [],
            date: payload.date
        }
    })
)

const cropsConditionsSlice = createSlice({
    name: 'cropsConditionsDashboardSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        applyExtraReducer(builder, fetchCropsConditions)
    },
})

export const actions = { ...cropsConditionsSlice.actions, fetchCropsConditions }
export default cropsConditionsSlice.reducer